import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=c3a7faa0&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=c3a7faa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a7faa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a7faa0')) {
      api.createRecord('c3a7faa0', component.options)
    } else {
      api.reload('c3a7faa0', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=c3a7faa0&scoped=true&", function () {
      api.rerender('c3a7faa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-47nv6WJ24rFeb/JS/comp/PopupDialog.vue"
export default component.exports